import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import Button from '../Button';
import ProfilePhoto from '../ProfilePhoto';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import OPENAI_WIDGET from '../../../../widget/app/modules/constants/srcTypes';

const ProfileMenuButton = ({
  loading,
  onLogin,
  onProfile,
  open,
  sourceId,
  user,
}) => {
  if (sourceId === OPENAI_WIDGET) {
    return null;
  }

  const login = (
    <Button onClick={onLogin} variant="login" data-test-id="profile_menu-button-login">
      <TranslationProvider translationKey="login">
        <span>Log In</span>
      </TranslationProvider>
    </Button>
  );

  if (user) {
    const profileImageUrl = user?.profile_image_url; // eslint-disable-line camelcase
    const isGda = user?.is_global_dining_access; // eslint-disable-line camelcase
    return (
      <Button
        aria-expanded={open}
        aria-label={getTranslation({ translationKey: 'profile_menu', fallback: 'Profile menu' })}
        className={cx('ProfileMenuButton',
          { 'ProfileMenuButton--rga': isGda })}
        data-test-id="profile_menu-button-profile_toggle"
        onClick={onProfile}
        variant="no-style"
      >
        <div data-dd-privacy="mask">
          <ProfilePhoto isGda={isGda} url={profileImageUrl} size="34" />
        </div>
      </Button>
    );
  }

  if (loading) {
    return null;
  }

  return login;
};

ProfileMenuButton.propTypes = {
  loading: PropTypes.bool,
  onLogin: PropTypes.func.isRequired,
  onProfile: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  sourceId: PropTypes.string,
  user: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      profile_image_url: PropTypes.string,
      is_global_dining_access: PropTypes.bool,
    }),
  ]),
};

ProfileMenuButton.defaultProps = {
  loading: true,
  sourceId: undefined,
  user: undefined,
};

export default ProfileMenuButton;
